module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-11-zoom.ce092003.png";